import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Layout from './components/Layout/Layout'
import Home from './pages/Home/Home'
import Login from './pages/Auth/Login'
import Dashboard from './pages/Dashboard/Dashboard'
import Clients from './pages/Clients/Clients'
import Accounting from './pages/Accounting/Accounting'
import Financial from './pages/Financial/Financial'
import Reports from './pages/Reports/Reports'
import Notifications from './pages/Notifications/Notifications'
import Licenciamiento from './pages/Licenciamiento/Licenciamiento'
import AuditoriaNomina from './pages/Nomina/AuditoriaNomina'
import MiPlan from './pages/MiPlan/MiPlan'
import Registro from './pages/Registro/Registro'
import VerificarCorreo from './pages/Registro/VerificarCorreo'
import Recuperar from './pages/Auth/Recuperar'
import Legal from './pages/Legal/Legal'
import { useAuth } from './hooks/useAuth'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import { esRutaPublica } from './utils/registroPublico'

/**
 * Páginas sin sesión, fuera del layout de la aplicación. Las del registro de invitados se ven
 * aunque haya sesión: quien abre el QR desde un celular con otra cuenta abierta, o la liga de
 * verificación, no debe acabar en el dashboard de otro.
 */
const PAGINAS_PUBLICAS = [
  { path: '/registro', element: <Registro /> },
  { path: '/registro/verificar', element: <VerificarCorreo /> },
  { path: '/recuperar', element: <Recuperar /> },
  { path: '/legal/:tipo', element: <Legal /> },
]

function App() {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  const isLoginRoute = location.pathname === '/login'

  if (isLoginRoute) {
    return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
  }

  if (esRutaPublica(location.pathname)) {
    return (
      <Routes>
        {PAGINAS_PUBLICAS.map((p) => <Route key={p.path} path={p.path} element={p.element} />)}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Container fluid className="py-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/nomina/auditoria"
            element={
              <ProtectedRoute modulo="nomina">
                <AuditoriaNomina />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <ProtectedRoute modulo="contabilidad">
                <Accounting />
              </ProtectedRoute>
            }
          />
          {/* Financiero agrupa cuatro productos, así que la ruta no exige un módulo concreto:
              basta tener uno, y adentro cada pestaña se filtra por su cuenta. Pedir
              `facturacion` dejaría fuera a quien compró sólo cobranza. */}
          <Route
            path="/financial"
            element={
              <ProtectedRoute>
                <Financial />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute modulo="reportes">
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          {/* Configuración comercial. La ruta exige sesión; que sólo entre el superadmin lo
              valida el servidor (licencias_api.EsSuperAdmin), no este archivo. */}
          <Route
            path="/licenciamiento"
            element={
              <ProtectedRoute>
                <Licenciamiento />
              </ProtectedRoute>
            }
          />
          {/* Lo que el propio contador ve de su licencia. No exige rol: es lo suyo, y el
              endpoint sólo devuelve su licencia. */}
          <Route
            path="/mi-plan"
            element={
              <ProtectedRoute>
                <MiPlan />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Container>
    </Layout>
  )
}

export default App
